import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactSortable } from 'react-sortablejs';
import { useUnit } from 'hooks/units/index';
import styles from 'styles/Course.module.scss';
import { parseHtml } from 'helpers';
import { Popover } from 'antd';
import stylespopover from 'styles/Calendar.module.scss';
import { UnitIdContext } from 'pages/course/[slug]/unit/[unitId]';

const Ordering = ({ list, setList, question, test }) => {
  const unitSelected = useUnit();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const isFullscreenMode = useContext(UnitIdContext);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const formatAnswer = useMemo(
    () =>
      (question || unitSelected?.complete?.question)?.answers.map((answer) => ({
        content: answer,
      })),
    [(question || unitSelected?.complete?.question)?.answers],
  );

  useEffect(() => {
    if (test?.userQuestion?.result?.length) {
      let array = [];

      test?.userQuestion?.result?.map((data) => array.push({ content: data }));
      setList(array);
      sessionStorage.setItem('ordering', JSON.stringify(array));
    } else {
      sessionStorage.setItem('ordering', JSON.stringify(formatAnswer));
      setList(formatAnswer);
    }

    return () => {
      sessionStorage.removeItem('ordering');
    };
  }, [formatAnswer]);

  if (!list) return;
  const OrderingPopover = question?.explanation?.filter(
    (inItem) => inItem?.explanation,
  );
  return (
    <div>
      <ReactSortable
        className="mb-2"
        list={list}
        multiDrag
        animation={220}
        forceFallback
        easing="cubic-bezier(1, 0, 0, 1)"
        selectedClass={styles['item-section-selected']}
        setList={(data) => {
          sessionStorage.setItem('ordering', JSON.stringify(data));
          setList(data);
        }}
      >
        {list?.map((item, index) => (
          <div className={`${OrderingPopover.length ? 'mr-2' : ''}`}>
            <div
              key={index}
              className={
                `col cursor-pointer position-relative flexRow px-md-2 px-05 py-05 ordering-content-test ${styles['item-section-normal']}` +
                ` ${styles['item-section-enabled']}`
              }
              style={{ maxWidth: '40rem', '--labelcolor': '#c1c9d4' }}
            >
              <span className={`w-100 ${styles['item-unit-label']}`}>
                <span
                  className={`drag-overflow-image ${styles['item-unit-title']}`}
                >
                  {parseHtml(item?.content)}
                </span>
              </span>

              <div
                className="position-absolute"
                style={{ right: 0, left: '100%' }}
              >
                {question?.explanation?.map((inItem) =>
                  inItem?.content == item?.content && inItem?.explanation ? (
                    <div ref={containerRef} className="col odering-explain ">
                      <Popover
                        {...(isFullscreenMode?.active
                          ? { getPopupContainer: () => containerRef.current }
                          : {})}
                        placement={isFullscreenMode?.active ? 'left' : 'top'}
                        content={
                          <div
                            className={`Popover-responsive ${stylespopover.Popover_responsive}`}
                            onClick={hide}
                          >
                            {parseHtml(inItem?.explanation)}
                          </div>
                        }
                        trigger="click"
                        open={open}
                        onOpenChange={handleOpenChange}
                      >
                        {inItem?.explanation?.length > 0 && (
                          <img
                            className="i-icon"
                            src={'/images/course/expand-view.png'}
                            style={{ height: 14, color: '#646871' }}
                          />
                        )}
                      </Popover>
                    </div>
                  ) : null,
                )}
              </div>
            </div>
          </div>
        ))}
      </ReactSortable>
    </div>
  );
};

Ordering.propTypes = {
  list: PropTypes.array.isRequired,
  setList: PropTypes.func.isRequired,
};

export default Ordering;
